import { getFeatureFlags } from 'gen/api';
import { useQueryWithCallbacks } from '../../hooks/useQueryWithCallbacks';
import { QueryKeys } from '../queryKeys';

export enum FeatureFlags {
  NOVELTY_ANALYSIS = 'novelty-analysis',
  PD_NOVELTY_REPORT = 'pd-novelty-report',
  CIPO_AU_JURISDICTIONS = 'cipo-au-jurisdictions',
  OA_SG_JURISDICTION = 'oa-sg-jurisdiction',
  LITIGATION_BU_FILTERS = 'litigation-bu-filters',
  CREATE_DRAFT_FROM_DISCLOSURE = 'create-draft-from-disclosure',
  PT_DATASET_EXTRACTION = 'pt-dataset-extraction',
  GA_NOVELTY_ANALYSIS = 'ga-novelty-analysis',
  SIGMA_SEARCH = 'ia-sigma-search',
  GA_LANDSCAPE_SEARCH = 'ga-landscape-search',
  ENABLE_REACTION_SCHEMA_EDIT = 'enable-reaction-schema-edit',
  CHAT_EXPORT = 'chat-export',
  HACK_SIMPLIFIED_RESEARCH_PROJECTS = 'do-not-enable-simplified-research-projects',
  DATA_TABLE_MULTI_SELECT = 'data-table-multi-select',
  DATA_TABLE_DECIMAL = 'data-table-decimal',
  DATA_TABLE_CELL_RANGE = 'data-table-cell-range',
  DATA_TABLE_DASHBOARDS = 'data-table-dashboards',
  DATA_TABLE_ADVANCED_CHARTS = 'data-table-advanced-charts',
  DATA_TABLE_STRUCT_COLUMNS = 'data-table-struct-columns',
  UNIFIED_DIAGRAM_GENERATION = 'unified-diagram-generation',
  DIAGRAM_REFERENCE_IMAGE = 'diagram-reference-image',
  REGENERATION_REFERENCE_IMAGE = 'regeneration-reference-image',
  IP_OA_SETUP = 'ip-oa-setup',
  INSERT_KNOWLEDGE = 'insert-knowledge',
  DPMA_DOSSIER_FETCHING = 'dpma-dossier-fetching',
  TABLE_TEMPLATES = 'table-templates',
  CAD_FILES = 'cad-files',
  PROJECTS_ANALYTICS = 'projects-analytics',
  DIAGRAM_DRAWIO = 'diagram-drawio',
  DIAGRAM_DRAWIO_ALTERNATE_VERSION = 'diagram-drawio-alternate-version',
  DRAWIO_FORMAT_PANEL = 'drawio-format-panel',
  PRESIGNED_DOCX_UPLOAD = 'presigned-docx-upload',
  DATA_TABLE_FILE_COLUMN = 'data-table-file-column',
  COMPOUND_CDXML_SOURCE_OF_TRUTH = 'compound-cdxml-source-of-truth',
}

type IFeatureFlagMap = {
  [key in FeatureFlags]: boolean;
};

export const useGetUserFeatureFlags = ({ onSuccess }: { onSuccess?: (data: IFeatureFlagMap) => void } = {}) => {
  return useQueryWithCallbacks({
    queryKey: [QueryKeys.getUserFeatureFlags],
    queryFn: async () => {
      const { data } = await getFeatureFlags({ throwOnError: true });
      return data.featureFlags as IFeatureFlagMap;
    },
    onSuccess,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
};
